import { render, staticRenderFns } from "./DesignerServicesTable.vue?vue&type=template&id=3df392ac&"
import script from "./DesignerServicesTable.vue?vue&type=script&lang=js&"
export * from "./DesignerServicesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports